import React from 'react';

import { BookingDetails } from '@components/utilities/Bookings/BookingDetails';

export const CurrentBookingDetails: React.FC = () => {
  return <BookingDetails type="current" />;
};
